import Whisper from './Whisper';
export type { WhisperProps, WhisperInstance } from './Whisper';
export default Whisper;
